import React from 'react';
import { Box, Container, Typography, Grid, TextField, Button, Paper } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const Contact = () => {
  return (
    <Box id="contact" sx={{ bgcolor: '#0a2540', color: 'white', py: 12 }}>
      <Container maxWidth="lg">
        <Grid container spacing={8}>
          <Grid item xs={12} md={5}>
            <Typography variant="overline" sx={{ color: '#66bb6a', letterSpacing: 2 }}>GET IN TOUCH</Typography>
            <Typography variant="h2" sx={{ color: 'white', mb: 3 }}>Let's Start a Conversation</Typography>
            <Typography variant="body1" sx={{ opacity: 0.8, mb: 6 }}>
              Whether you need an STP design, an environmental audit, or agricultural water management, our experts are ready.
            </Typography>

            <Box sx={{ display: 'flex', gap: 2, mb: 4 }}>
              <LocationOnIcon color="secondary" />
              <Box>
                <Typography variant="subtitle1" fontWeight="bold">Vizag Office</Typography>
                <Typography variant="body2" sx={{ opacity: 0.7 }}>
                  39-5-27/3, Sector 5, Murali Nagar,<br/>Visakhapatnam, Andhra Pradesh
                </Typography>
              </Box>
            </Box>

            <Box sx={{ display: 'flex', gap: 2, mb: 4 }}>
              <PhoneIcon color="secondary" />
              <Box>
                <Typography variant="subtitle1" fontWeight="bold">Call Us</Typography>
                <Typography variant="body2" sx={{ opacity: 0.7 }}>+91 9246774205</Typography>
                <Typography variant="body2" sx={{ opacity: 0.7 }}>+91 9666118818</Typography>
              </Box>
            </Box>

            <Box sx={{ display: 'flex', gap: 2 }}>
              <EmailIcon color="secondary" />
              <Box>
                <Typography variant="subtitle1" fontWeight="bold">Email Us</Typography>
                <Typography variant="body2" sx={{ opacity: 0.7 }}>info@greenbluein.com</Typography>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} md={7}>
            <Paper elevation={0} sx={{ p: 5, borderRadius: 2 }}>
              <Typography variant="h5" color="primary" gutterBottom fontWeight="bold">Send a Message</Typography>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="First Name" variant="outlined" />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="Last Name" variant="outlined" />
                </Grid>
                <Grid item xs={12}>
                  <TextField fullWidth label="Email Address" variant="outlined" />
                </Grid>
                
                <Grid item xs={12}>
                  <Button variant="contained" color="secondary" size="large" fullWidth sx={{ py: 1.5 }}>
                    Submit Inquiry
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Contact;